import { useProStatus } from 'networking/revenueCat/hooks/useProStatus';
import useBoxes from 'networking/mindfeed/hooks/useBoxes';
import useCollections from 'networking/mindfeed/hooks/useCollections';

// Free Tier Limits — freemium only caps the number of boxes (per space) and
// collections (per box). Memo count / memo types are no longer restricted.
export const FREE_TIER_LIMITS = {
  boxCountLimit: 5,
  collectionCountLimit: 5,
};

export interface FreemiumRestrictions {
  // True for a free user who has hit the box limit (must upgrade to add more).
  isBoxLimitReached: boolean;
  // True for a free user who has hit the collection limit in the current box.
  isCollectionLimitReached: boolean;
}

export const useFreemiumRestrictions = (): FreemiumRestrictions => {
  const { isPro } = useProStatus();
  const { data: boxes = [] } = useBoxes();
  const { data: collections = [] } = useCollections();

  return {
    isBoxLimitReached: !isPro && boxes.length >= FREE_TIER_LIMITS.boxCountLimit,
    isCollectionLimitReached:
      !isPro && collections.length >= FREE_TIER_LIMITS.collectionCountLimit,
  };
};
